import { useMutation } from '@tanstack/react-query'
import { oauth2DashboardApi } from '../api/oauth2DashboardApi'
import { toast } from '@/integrations/toaster-provider'

export default function useResetOAuthMutation(onSuccess: () => void) {
  return useMutation({
    mutationFn: oauth2DashboardApi.reset,
    onSuccess: () => {
      toast.success('OAuth2 configuration reset successfully')
      onSuccess()
    },
    onError: (error: Error) => {
      toast.error(`Failed to reset OAuth2: ${error.message || 'Unknown error'}`)
    },
  })
}
